var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVirtualMachinesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 60,
    viewBox: "0 0 105 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6FE61A",
    d: "M0 0h80v60H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010118",
    d: "M55 20h25v30H55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 20h25v30H80zM0 0h80v10H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zm6 2a2 2 0 100-4 2 2 0 000 4zM38.56 26.94l8.561 8.56-8.56 8.56-2.122-2.12L41.38 37H10v-3h31.379l-4.94-4.94 2.122-2.12z",
    fill: "#010118"
  })));
}

export default SvgVirtualMachinesinline;